interface Gender {
  [key: string]: string;
}

export const gender: Gender = { "1": "男性", "2": "女性" };
